import React from "react";
import { Table } from "reactstrap";

import EmailNotificationRow from "./row/EmailNotificationRow";

const EmailNotificationsTable = ({ emailNotifications }) => {
  const rows = emailNotifications.map((entry) => (
    <EmailNotificationRow key={entry.id} entry={entry} />
  ));

  return (
    <React.Fragment>
      <Table  >
        <thead className="thead-light">
          <tr>
            <th style={{ width: 260 }}>Notification Type</th>
            <th style={{ width: 650 }}>Notification explanation</th>
            <th style={{ width: "auto" }} >Mail, receiving notifications</th>
            <th style={{ width: 30 }}>Active</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </Table>
    </React.Fragment>
  );
};

export default EmailNotificationsTable;



// WEBPACK FOOTER //
// ./src/features/organization/pages/email-notifications/email-notifications-table/EmailNotificationsTable.jsx